import React, { useEffect, useState, useContext } from 'react';
import { Table, Button } from 'antd';
import { getInstitutions } from '../../../actions';
import { Icon } from 'semantic-ui-react';
import { Context } from '../../../defaults';
import moment from 'moment';
import { InstitutionModal } from './InstitutionsModal';

function InstitutionsTable({ added, paymentsTypes, institutionsType, languagesType }) {
  const [institutions, setInstitutions] = useState();
  const { dictionary, language } = useContext(Context);
  const [modalProps, setModalProps] = useState({
    visible: false,
    actionType: null,
    currentInstitution: null,
  });
  const allSelectValue = {
    institutionsType,
    languagesType,
    paymentsTypes,
  };

  useEffect(() => {
    getInstitutions().then(({ data }) => setInstitutions(data));
  }, [added]);

  useEffect(() => {
    getInstitutions().then(({ data }) => setInstitutions(data));
  }, []);

  const columns = [
    {
      title: `${dictionary?.Name[language]}`,
      dataIndex: 'name',
      key: 'name',
      fixed: 'left',
    },
    {
      title: `${dictionary?.Description[language]}`,
      dataIndex: 'description',
      key: 'description',
      fixed: 'left',
    },
    {
      title: `${dictionary?.City[language]}`,
      dataIndex: 'city',
      key: 'city',
    },
    {
      title: `${dictionary.Address[language]}`,
      dataIndex: 'address',
      key: 'address',
    },
    {
      title: `${dictionary?.RegDate[language]}`,
      dataIndex: 'regDate',
      key: 'regDate',
      render: (date) => (date !== '0001-01-01T00:00:00' ? moment(date).format('L') : ''),
    },
    {
      title: `${dictionary?.PaymentType[language]}`,
      dataIndex: 'paymentTypeId',
      key: 'paymentTypeId',
      render: (id) => paymentsTypes && paymentsTypes.find((el) => el.id === id)?.name,
    },
    {
      title: `${dictionary?.InstitutionType[language]}`,
      dataIndex: 'institutionTypeId',
      key: 'institutionTypeId',
      render: (id) => institutionsType && institutionsType.find((el) => el.id === id)?.name,
    },
    {
      title: `${dictionary?.Language[language]}`,
      dataIndex: 'langId',
      key: 'langId',
      render: (id) => languagesType && languagesType.find((el) => el.id === id)?.name,
    },
    {
      title: `${dictionary?.Action[language]}`,
      key: 'action',
      width: 100,
      fixed: 'right',
      render: ({ id }) => (
        <Button
          onClick={() => {
            setModalProps({
              visible: !modalProps.visible,
              actionType: 'edit',
              currentInstitution: institutions && institutions.find((el) => el.id === id),
            });
          }}>
          <Icon
            name="edit"
          />
        </Button>
      ),
    },
  ];

  function closeModal() {
    setModalProps({ visible: false });
    getInstitutions().then(({ data }) => setInstitutions(data));
  }




  return (
    <React.Fragment>
      <InstitutionModal
        modalProps={modalProps}
        selectValue={allSelectValue}
        closeModal={closeModal}
      />
      <Table
        style={{ marginTop: 24 }}
        columns={columns}
        dataSource={institutions}
        scroll={{ x: 2000 }}
        rowKey="id"
      />
    </React.Fragment>
  );
}

export default InstitutionsTable;
